/* Color.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./Color.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback, memo } from 'react';
import EditorDoneIcon from '@atlaskit/icon/core/migration/check-mark--editor-done';
import Tooltip from '@atlaskit/tooltip';
var buttonWrapperStyles = null;
var buttonStyles = null;

/**
 * Individual color palette item component
 * Displays a single color swatch with tooltip and selection state
 */
export var Color = /*#__PURE__*/memo(function (_ref) {
  var autoFocus = _ref.autoFocus,
    tabIndex = _ref.tabIndex,
    value = _ref.value,
    label = _ref.label,
    isSelected = _ref.isSelected,
    borderColor = _ref.borderColor,
    _ref$checkMarkColor = _ref.checkMarkColor,
    checkMarkColor = _ref$checkMarkColor === void 0 ? "var(--ds-icon-inverse, #FFFFFF)" : _ref$checkMarkColor,
    hexToPaletteColor = _ref.hexToPaletteColor,
    decorator = _ref.decorator,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown;
  var colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
  var handleMouseDown = useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleClick = useCallback(function (e) {
    e.preventDefault();
    onClick(value, label);
  }, [onClick, value, label]);
  var handleKeyDown = useCallback(function (e) {
    if (!onKeyDown) {
      return;
    }
    e.preventDefault();
    onKeyDown(value, label, e);
  }, [onKeyDown, value, label]);
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: label
  }, /*#__PURE__*/React.createElement("span", {
    className: ax(["_2rko12b0 _1h6d1j28 _1dqonqa1 _189ee4h9 _1e0c1txw _4cvr1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _858umuej _jyzfmuej _4cvxmuej"])
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": label,
    role: "radio",
    "aria-checked": isSelected,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onMouseDown: handleMouseDown,
    tabIndex: tabIndex,
    style: {
      backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
      border: "var(--ds-border-width, 1px)".concat(" solid ", borderColor)
    },
    autoFocus: autoFocus,
    className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko12b0 _19it1ps9 _4t3icr4y _1bsbcr4y _bfhkm7j4 _80omtlke _1e0c1ule _kqswh2mm _y2mv1q03 _1bg4v77o"])
  }, !decorator && isSelected && /*#__PURE__*/React.createElement(EditorDoneIcon, {
    color: checkMarkColor,
    LEGACY_primaryColor: checkMarkColor,
    label: ""
  }), decorator)));
});